import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

const riaTypes = [
{ label: 'Headquarters Outside Us', value: 'riatype_headquartersoutsideus' },
{ label: 'Internet Investment Adviser', value: 'riatype_internetinvestmentadviser' },
{ label: 'Wrap Fee Program Adviser', value: 'riatype_wrapfeeprogramadviser' }
];


export default class RiaTypes extends React.Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        value: PropTypes.any,
        name: PropTypes.string.isRequired,
        multi: PropTypes.bool.isRequired,
        hideTypes: PropTypes.array,
    };

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(selectedOptions) {
        let selectedValue = null;
        let selectedLabel = null;
        if (this.props.multi) {
            selectedValue = selectedOptions ? selectedOptions.map(el => el.value) : [];
            selectedLabel = selectedOptions ? selectedOptions.map(el => el.label) : [];
        } else if (selectedOptions) {
            selectedValue = selectedOptions.value;
            selectedLabel = selectedOptions.label;
        }

        this.props.onChange({
            target: {
                name: this.props.name,
                value: selectedValue,
                label: selectedLabel,
            }
        });
    }

    render() {
        let selectedTypes = this.props.value
            ? riaTypes.filter(row => this.props.value.indexOf(row.value) >= 0)
            : [];
        let displayTypes = this.props.hideTypes
            ? riaTypes.filter(row => this.props.hideTypes.indexOf(row.value) < 0)
            : riaTypes;

        return <Select
            closeMenuOnSelect={!this.props.multi}
            value={selectedTypes}
            isMulti={this.props.multi}
            options={displayTypes}
            onChange={this.handleChange}
            isClearable={true}
            placeholder={this.props.multi ? 'Select RIA Type(s)' : 'Select RIA Types'}
        />;
    }
}
